import { Result, err, ok } from "neverthrow"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { ApptEncounter, selectApptEncounters } from "../dal/ldbApptEncounter"

export class ApptEncounterGuidSelector {
	private selectError?: FusionError
	private rows: ApptEncounter[] = []

	static async create(upn: string) {
		const selector = new ApptEncounterGuidSelector()
		const r = await selectApptEncounters(upn)
		if(r.isErr()) {
			selector.selectError = r.error
		} else {
			selector.rows = r.value
		}
		return selector
	}

	get(serviceApptId: string): Result<string|null, FusionError> {
		if(this.selectError) {
			return err(serializeFusionError('ApptEncounterGuidSelector', this.selectError))
		}
		for(let row of this.rows) {
			if(row.serviceApptId === serviceApptId) {
				if(row.error) {
					return err(serializeFusionError('ApptEncounterGuidSelector', row.error))
				}
				return ok(row.encounterGuid)
			}
		}
		return ok(null)
	}

	// "must" because null is an error;
	// we are expecting this value to be in the table
	mustGet(serviceApptId: string): Result<string, FusionError> {
		const r = this.get(serviceApptId)
		if(r.isErr()) {
			return err(r.error)
		}
		if(!r.value) {
			return err(serializeFusionError('ApptEncounterGuidSelector', `null apptEncounter for '${serviceApptId}'`))
		}
		return ok(r.value)
	}
}
